<script lang="ts">
  import Alert from '$shared/atoms/Alert/Alert.svelte';
  import { AlertType } from '$shared/atoms/Alert/AlertProps';
  import { AlertOption } from '$provider/models/AlertOption';

  interface Props {
    list?: any;
    count?: number;
    onclose?: (payload: string) => void;
  }

  let { list = [], count = 3, onclose }: Props = $props();

  let currentList = $derived((() => {
    if (list.length <= count) {
      return [...list];
    }
    return list.slice(0, count);
  })());

  const onClickClose = (id: string) => {
    onclose?.(id);
  };
</script>

<div class="comp-grouped-alerts">
  {#each currentList as item, index}
    <div class="alert-item">
      <Alert
        data={item.message}
        options={AlertOption.from(item.type || AlertType.Info, item.closeIn)}
        maxWidth={item.maxWidth}
        closable={item.closable}
        onclose={() => {
          onClickClose(item.id);
        }}
      />
    </div>
  {/each}
</div>

<style src="./GroupedAlerts.css">
</style>
